module.exports = __webpack_public_path__ + "img/stretch.c116ce2e.png";